import { Stack, useRouter } from 'expo-router';
import { CustomTextStyles } from '@/components/CustomText';
import { HeaderBackButton } from "expo-router/react-navigation";
import { AppText } from '@/components/AppText';
import { HeaderLeft } from '@/components/HeaderLeft';

export default function StackedProfile() {
  const router = useRouter();
  
  return (
    <Stack
      screenOptions={({ navigation }) => ({
        headerTitleStyle: CustomTextStyles.headerTitle,

        // Remove horizontal bottom line for header
        headerShadowVisible: false,

        headerStyle: {
          backgroundColor: 'transparent',
        },
        
        headerBackTitle: '',

        headerBackButtonDisplayMode: 'minimal',
                
        headerTitle: (props) => <AppText {...props} style={CustomTextStyles.headerTitle} />,

        headerLeft: () => <HeaderLeft />,
      })}
    >
      <Stack.Screen
        name="[manage_community_id]"
        options={{ title: 'Manage', headerShown: false }}
      />
    </Stack>
  );
}
